<template>
    <div :style="{ width: size, height: size }" class="reddot" ref="reddot"></div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/app.scss';
  .reddot{
      display: inline-block;
      position: relative;
      width: 10px;
      height: 10px;
      box-sizing: border-box;
      border-radius: 50%;
      background-color: $watermelon;
      overflow: hidden;
      backface-visibility: hidden;
      mix-blend-mode: darken;
      @include breakpoint('s'){
        mix-blend-mode: normal;
      }
    }
</style>
